import moment from "moment";
import { message } from "antd";
import pick from "lodash/pick";
import omit from "lodash/omit";
import get from "lodash/get";
import * as employeesServices from "../services/employees";

const RESOURCE = "employees";
const transfromDocument = (record) => {
  if (record.created) {
    const createdAt = record.created;
    record.created = moment.unix(createdAt);
  }
  if (record.updated_at) {
    const updatedAt = record.updated_at;
    record.updated_at = moment.unix(updatedAt);
  }

  return record;
};

export default {
  namespace: "employees",

  state: {
    data: {
      list: [],
      pagination: {
        anchor: "",
        listAnchor: {
          1: "",
        },
      },
    },
    submitting: false,
    formTitle: "",
    formID: "",
    formVisible: false,
    formData: {},
  },

  effects: {
    *fetch({ payload, callback }, { call, put }) {
      let list = [];
      try {
        const response = yield call(employeesServices.getList, payload);
        if (response) {
          if (response.employees) {
            list = response.employees.map((item) => {
              transfromDocument(item);
              return item;
            });
          }
          yield put({
            type: "save",
            payload: {
              list,
              pagination: {
                total: response.total,
                anchor: get(response, ["anchor"], ""),
                listAnchor: {
                  [((payload && payload.current) || 1) + 1]: get(
                    response,
                    ["anchor"],
                    ""
                  ),
                },
              },
            },
          });
        }
      } catch (error) {
        console.log("*fetch -> error", error);
      }
      if (callback) {
        callback(list);
      }
    },
    *loadForm({ payload, callback }, { put }) {
      yield put({
        type: "changeFormVisible",
        payload: true,
      });

      yield [
        put({
          type: "saveFormType",
          payload: payload.type,
        }),
        put({
          type: "saveFormID",
          payload: "",
        }),
      ];
      if (payload.type === "A") {
        yield [
          put({
            type: "saveFormTitle",
            payload: "Thêm mới",
          }),
          put({
            type: "saveFormData",
            payload: {
              status: "1",
            },
          }),
        ];
      } else if (payload.type === "E") {
        yield [
          put({
            type: "saveFormTitle",
            payload: `Chỉnh sửa ${payload.id}`,
          }),
          put({
            type: "saveFormID",
            payload: payload.id,
          }),
          put({
            type: "fetchForm",
            payload: {
              id: payload.id,
            },
          }),
        ];
      }
      if (callback) {
        callback();
      }
    },
    *fetchForm({ payload, callback }, { call, put }) {
      let response;
      try {
        response = yield call(employeesServices.get, payload.id, payload);
        if (response) transfromDocument(response);
        yield [
          put({
            type: "saveFormData",
            payload: response,
          }),
        ];
      } catch (error) {
        console.log("*fetch -> error", error);
      }
      if (callback) {
        callback(response);
      }
    },
    *submit({ payload, callback }, { call, put, select }) {
      try {
        yield put({
          type: "changeSubmitting",
          payload: true,
        });
  
        const params = { ...payload };
        const formType = yield select((state) => state.employees.formType);
  
        let success = false;
        let response;
        try {
          if (formType === "E") {
            const id = yield select((state) => state.employees.formID);
            if (!params.id) {
              params.id = id;
            }
            response = yield call(employeesServices.update, id, params);
            console.log("🚀 ~ file: employees.js ~ line 167 ~ *submit ~ response", response)
            
            success = true;
          } else {
            response = yield call(employeesServices.create, params);
            success = true;
          }
        } catch (error) {
          success = false;
        }
  
        yield put({
          type: "changeSubmitting",
          payload: false,
        });
  
        if (success) {
          message.success("Thành công");
          yield put({
            type: "changeFormVisible",
            payload: false,
          });
        }
        if (callback && success) {
          callback(response);
        }
      } catch (error) {
        console.log("error error",  error)
      }
     
    },
  },

  reducers: {
    save(state, action) {
      let pagi = get(action.payload, ["pagination"], {});
      pagi = omit(pagi, ["listAnchor"]);
      const aPagi = get(action.payload, "pagination", {});
      const sPagi = get(state.data, "pagination", {});
      const listAnchor = Object.assign(
        {},
        get(aPagi, "listAnchor", {}),
        get(sPagi, "listAnchor", {})
      );
      const pagination = Object.assign({}, sPagi, { listAnchor }, pagi);
      return {
        ...state,
        data: {
          ...state.data,
          list: action.payload.list,
          pagination,
        },
      };
    },
    changeFormVisible(state, { payload }) {
      return { ...state, formVisible: payload };
    },
    saveFormTitle(state, { payload }) {
      return { ...state, formTitle: payload };
    },
    saveFormType(state, { payload }) {
      return { ...state, formType: payload };
    },
    saveFormID(state, { payload }) {
      return { ...state, formID: payload };
    },
    saveFormData(state, { payload }) {
      return { ...state, formData: payload };
    },
    changeSubmitting(state, { payload }) {
      return { ...state, submitting: payload };
    },
  },
};
